import Icon from '@material-ui/icons/ViewList';
import List from './SupplyLotList';

export default {
    list: List,
    icon: Icon,
};
